import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer/Footer';
import HeaderServices from '../components/Header/HeaderServices';
import FooterServices from '../components/Footer/FooterServices';
import Catalogo from '../components/MainPageComponents/catalogo';
import ImageSlider from '../components/MainPageComponents/imageslider';
import InsigniaProduct from '../components/MainPageComponents/insignia';
import ExclusiveBenefits from '../components/MainPageComponents/exclusivebenefits';
import OrderNow from '../components/MainPageComponents/ordernow';
import { UserProvider, useUser } from '../Context/UserContext';
import SearchContainer from "../components/MainPageComponents/searchContainer";
import './homeServices.css';

const HomeServices = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Simular carga de contenido
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 800);

        return () => clearTimeout(timer);
    }, []);

    const handleImageClick = (imageSrc, index) => {
        setSelectedImage({ src: imageSrc, index });
    };

    const closeModal = () => {
        setSelectedImage(null);
    };

    // Portfolio images
    const portfolioImages = [
        {
            src: "/images/PCB/PCB1.png",
            title: "PCBs Multicapa",
            description: "Diseños compactos y acorde a las necesidades",
            category: "Diseño"
        },
        // {
        //     src: "/images/pcb.jpg",
        //     title: "Prototipo IoT",
        //     description: "Desarrollo de prototipo para dispositivos IoT",
        //     category: "Prototipado"
        // },
        {
            src: "/images/PCB/PCB2.png",
            title: "PCB de Potencia",
            description: "No más cables sueltos",
            category: "Comodidad"
        },
        // {
        //     src: "/images/pcb.jpg",
        //     title: "Microcontrolador ARM",
        //     description: "PCB optimizada para microcontroladores ARM",
        //     category: "Embedded"
        // },
        // {
        //     src: "/images/pcb.jpg",
        //     title: "Circuito RF",
        //     description: "Diseño especializado en radiofrecuencia",
        //     category: "RF"
        // },
        // {
        //     src: "/images/pcb.jpg",
        //     title: "Sistema de Potencia",
        //     description: "PCB para manejo de alta potencia",
        //     category: "Potencia"
        // }
    ];

    if (isLoading) {
        return (
            <div className="services-loading-screen">
                <div className="loading-spinner"></div>
                <h2>Cargando Volteon Services...</h2>
                <div className="loading-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        );
    }

    return (
        <UserProvider>
            <HeaderServices />

            {/* Hero Section con Logo */}
            <section className="services-hero">
                <div className="hero-content">
                    <div className="hero-text">
                        <h1 className="hero-title">
                            <span className="gradient-text">Volteon Services</span>
                            <span className="hero-subtitle">Diseño Electrónico Profesional</span>
                        </h1>
                        <p className="hero-description">
                            Transformamos tus ideas en realidad con diseños de PCB de alta calidad, 
                            prototipado rápido y consultoría técnica especializada.
                        </p>
                        <div className="hero-stats">
                            <div className="stat">
                                <span className="stat-number">30+</span>
                                <span className="stat-label">PCBs Diseñadas</span>
                            </div>
                            <div className="stat">
                                <span className="stat-number">5</span>
                                <span className="stat-label">Días Máximo</span>
                            </div>
                            <div className="stat">
                                <span className="stat-number">100%</span>
                                <span className="stat-label">Satisfacción</span>
                            </div>
                        </div>
                    </div>
                    <div className="hero-logo-visual">
                        <img
                            src="/images/logo_Services.png"
                            alt="Volteon Services Logo"
                            className="hero-logo-main"
                        />
                    </div>
                </div>
            </section>

            {/* Services Section Mejorada */}
            
            {/* <section className="services-section">
                <div className="container">
                    <h2 className="section-title">
                        <span className="title-accent">Nuestros</span> Servicios
                    </h2>
                    <div className="services-grid services-grid-single">
                        <div className="service-card pcb-design">
                            <div className="service-icon">
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
                                </svg>
                            </div>
                            <h3>Diseño de PCB</h3>
                            <p>Diseños personalizados desde esquemáticos hasta layout final con las mejores prácticas de la industria.</p>
                            <ul className="service-features">
                                <li>Diseño esquemático profesional</li>
                                <li>Layout optimizado</li>
                                <li>Simulaciones y validaciones</li>
                                <li>Documentación completa</li>
                            </ul>
                            <a href="/servicios/PCB" className="service-btn">Conocer más</a>
                        </div>

                       
                        <div className="service-card prototyping">
                            <div className="service-icon">
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                                </svg>
                            </div>
                            <h3>Prototipado Rápido</h3>
                            <p>De la idea al prototipo funcional en tiempo récord con fabricación local y testing completo.</p>
                            <ul className="service-features">
                                <li>Fabricación en 3-5 días</li>
                                <li>Testing y validación</li>
                                <li>Ensamblaje profesional</li>
                                <li>Iteraciones rápidas</li>
                            </ul>
                            <a href="/servicios/prototipado" className="service-btn">Conocer más</a>
                        </div>

                        <div className="service-card consulting">
                            <div className="service-icon">
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                </svg>
                            </div>
                            <h3>Consultoría Técnica</h3>
                            <p>Asesoría especializada para optimizar tus proyectos electrónicos y resolver desafíos técnicos complejos.</p>
                            <ul className="service-features">
                                <li>Análisis de viabilidad</li>
                                <li>Optimización de diseños</li>
                                <li>Selección de componentes</li>
                                <li>Troubleshooting avanzado</li>
                            </ul>
                            <a href="/servicios/consultoria" className="service-btn">Conocer más</a>
                        </div>
                    
                    </div>
                </div>
            </section> */}

            {/* Sección PCB Rediseñada */}
            <section className="pcb-service-section">
                <div className="container">
                    <div className="pcb-content">
                        <div className="pcb-text">
                            <h2 className="pcb-title">
                                <span className="title-main">Creación de</span>
                                <span className="title-accent">PCBs</span>
                            </h2>
                            <p className="pcb-description">
                                Construye tu PCB con Volteon y experimenta un servicio premium 
                                con entrega garantizada en máximo 5 días hábiles.
                            </p>
                            <div className="pcb-features">
                                <div className="feature-item">
                                    <div className="feature-icon">
                                        <svg viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                        </svg>
                                    </div>
                                    <span>Diseño profesional personalizado</span>
                                </div>
                                <div className="feature-item">
                                    <div className="feature-icon">
                                        <svg viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                        </svg>
                                    </div>
                                    <span>Entrega máximo en 5 días</span>
                                </div>
                                <div className="feature-item">
                                    <div className="feature-icon">
                                        <svg viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                                        </svg>
                                    </div>
                                    <span>Garantía de calidad premium</span>
                                </div>
                            </div>
                            <p className="pcb-additional-info">
                                También disponible servicio de consultoría técnica y 
                                optimización de diseños existentes.
                            </p>
                            <a href="/servicios/PCB" className="pcb-btn">
                                <span>Ordena ahora</span>
                                <svg className="btn-arrow" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
                                </svg>
                            </a>
                        </div>
                        <div className="pcb-image">
                            <div className="image-container">
                                <img 
                                    src="/images/pcb.jpg" 
                                    alt="PCB Design Service"
                                    className="pcb-img"
                                />
                                <div className="image-overlay">
                                    <div className="overlay-content">
                                        <span className="overlay-badge">Calidad Asegurada</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Portfolio Section */}
            <section className="portfolio-section">
                <div className="container">
                    <h2 className="portfolio-title-option3"> {/* o option2, option3, etc. */}
                        <span className="title-main">Nuestro</span>
                        <span className="title-accent">Portafolio</span>
                    </h2>
                    {/* <p className="portfolio-subtitle">
                        Algunos de nuestros proyectos más destacados en diseño electrónico
                    </p> */}
                    
                    <div className="portfolio-grid">
                        {portfolioImages.map((image, index) => (
                            <div 
                                key={index} 
                                className="portfolio-item"
                                onClick={() => handleImageClick(image.src, index)}
                            >
                                <div className="portfolio-image-container">
                                    <img 
                                        src={image.src} 
                                        alt={image.title}
                                        className="portfolio-image"
                                    />
                                    <div className="portfolio-overlay">
                                        <div className="portfolio-info">
                                            <span className="portfolio-category">{image.category}</span>
                                            <h3 className="portfolio-item-title">{image.title}</h3>
                                            <p className="portfolio-description">{image.description}</p>
                                            <div className="portfolio-btn">Ver detalles</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Modal para imágenes */}
            {selectedImage && (
                <div className="image-modal" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close" onClick={closeModal}>&times;</button>
                        <img 
                            src={selectedImage.src} 
                            alt={`Portfolio ${selectedImage.index + 1}`}
                            className="modal-image"
                        />
                        <div className="modal-info">
                            <h3>{portfolioImages[selectedImage.index].title}</h3>
                            <p>{portfolioImages[selectedImage.index].description}</p>
                            <span className="modal-category">{portfolioImages[selectedImage.index].category}</span>
                        </div>
                    </div>
                </div>
            )}

            {/* CTA Section */}
            <section className="cta-section">
                <div className="container">
                    <div className="cta-content">
                        <h2>¿Listo para empezar tu proyecto?</h2>
                        <p>Contáctanos hoy y convierte tu idea en realidad con nuestro equipo de expertos</p>
                        <a href="/servicios/PCB" className="cta-button">
                            Iniciar Proyecto
                            <svg className="cta-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </section>

            <FooterServices />
        </UserProvider>
    );
};

export default HomeServices;